import React, { useEffect } from 'react'
import { useErrorMessageState } from 'hooks/ui/useErrorMessageState'

export function FormErrorMessageListener({ errors, submitCount, getErrorMessage, someFieldHasError }) {

    const { showErrorMessage, hideErrorMessage } = useErrorMessageState()

    const formWasSubmitted = submitCount > 0

    useEffect(() => {
      if (formWasSubmitted && someFieldHasError(errors)) {
        showErrorMessage(getErrorMessage(errors));
      } 
      if(formWasSubmitted && !someFieldHasError(errors)) {
        hideErrorMessage()
      }
    }, [errors, submitCount]);

    return (
        <></>
    )
}